import { assetPrefix } from 'constants/app';
import Image from 'global/Image';
import { Title, ValueCustomLayout, ValuePoints } from './styled';
import { valuePoint } from './constants';
import ValuePoint from './ValuePoint';

const CustomLayout = () => (
  <ValueCustomLayout>
    <Title>
      Trading Saham dengan <span className="green"> Custom Layout</span>{' '}
    </Title>
    <div className="images-wrapper">
      <Image src="/images/monitor-bezel.svg" className="image" alt="" />
      <video autoPlay loop muted playsInline className="image-example">
        <source src={`${assetPrefix}/homepage/trading-custom-layout.mp4`} />
      </video>
    </div>
    <ValuePoints className="value-points" gap={40}>
      {valuePoint.map((item, index) => (
        <div key={`value-point-${index + 1}`}>
          <ValuePoint text={item.text} subText={item.subText} />
        </div>
      ))}
    </ValuePoints>
  </ValueCustomLayout>
);

export default CustomLayout;
